


import React, { Suspense } from 'react'

const Banner = React.lazy(() => import('../layouts/Banner'));
const Feature = React.lazy(() => import('../layouts/Feature'));
const Review = React.lazy(() => import('../layouts/Review'));
const Member = React.lazy(() => import('../layouts/Member'));


function Home(){

    return (

        <React.Fragment>
            <Suspense fallback={<div>Түр хүлээнэ үү....</div>}>
                <Banner />
                <Feature />
                {/* <Review />
                {/* 
                <About /> 
                <News />
                */}
                
             
            </Suspense>

        </React.Fragment>
        
    );
}

export default React.memo(Home);